function IconFinancialLeadership() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
      <path d="M12 50V20" stroke="#F5B400" strokeWidth="3" />
      <path d="M24 50V30" stroke="#F5B400" strokeWidth="3" />
      <path d="M36 50V14" stroke="#F5B400" strokeWidth="3" />
      <path d="M48 50V24" stroke="#F5B400" strokeWidth="3" />
      <path d="M10 54H54" stroke="#F5B400" strokeWidth="3" />
      <path d="M18 18L30 12L42 20L54 8" fill="none" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconStrategicProcurement() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
      <path
        d="M22 34L14 26C10 22 10 16 14 12C18 8 24 8 28 12L32 16L36 12C40 8 46 8 50 12C54 16 54 22 50 26L42 34"
        fill="none"
        stroke="#F5B400"
        strokeWidth="3"
      />
      <path d="M20 32L28 40C30 42 34 42 36 40L44 32" fill="none" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconInternationalTrade() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
      <circle cx="32" cy="32" r="22" fill="none" stroke="#F5B400" strokeWidth="3" />
      <path d="M10 32H54" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 10C40 18 40 46 32 54" fill="none" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 10C24 18 24 46 32 54" fill="none" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconBusinessOperations() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
      <circle cx="32" cy="32" r="8" fill="none" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 10V18M32 46V54M10 32H18M46 32H54" stroke="#F5B400" strokeWidth="3" />
      <path d="M18 18L23 23M41 41L46 46M46 18L41 23M18 46L23 41" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconComplianceManagement() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
      <path
        d="M32 10L50 18V30C50 42 42 50 32 54C22 50 14 42 14 30V18L32 10Z"
        fill="none"
        stroke="#F5B400"
        strokeWidth="3"
      />
      <path d="M24 32L30 38L42 24" fill="none" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconSupplyChainExcellence() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
      <rect x="10" y="24" width="28" height="16" fill="none" stroke="#F5B400" strokeWidth="3" />
      <rect x="38" y="28" width="12" height="12" fill="none" stroke="#F5B400" strokeWidth="3" />
      <circle cx="20" cy="46" r="4" fill="#F5B400" />
      <circle cx="44" cy="46" r="4" fill="#F5B400" />
    </svg>
  )
}

function IconHumanResourceDevelopment() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
      <circle cx="24" cy="22" r="6" fill="none" stroke="#F5B400" strokeWidth="3" />
      <circle cx="40" cy="22" r="6" fill="none" stroke="#F5B400" strokeWidth="3" />
      <path d="M14 46C14 38 18 34 24 34C30 34 34 38 34 46" fill="none" stroke="#F5B400" strokeWidth="3" />
      <path d="M30 46C30 38 34 34 40 34C46 34 50 38 50 46" fill="none" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconVendorRelationshipManagement() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
      <circle cx="20" cy="18" r="5" fill="none" stroke="#F5B400" strokeWidth="3" />
      <circle cx="44" cy="18" r="5" fill="none" stroke="#F5B400" strokeWidth="3" />
      <circle cx="32" cy="42" r="5" fill="none" stroke="#F5B400" strokeWidth="3" />
      <line x1="20" y1="23" x2="32" y2="37" stroke="#F5B400" strokeWidth="3" />
      <line x1="44" y1="23" x2="32" y2="37" stroke="#F5B400" strokeWidth="3" />
      <line x1="20" y1="18" x2="44" y2="18" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

export const leadershipExpertiseIcons = {
  financial: IconFinancialLeadership,
  procurement: IconStrategicProcurement,
  trade: IconInternationalTrade,
  operations: IconBusinessOperations,
  compliance: IconComplianceManagement,
  supplyChain: IconSupplyChainExcellence,
  humanResource: IconHumanResourceDevelopment,
  vendor: IconVendorRelationshipManagement,
}
